import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../../features/on-boarding/redux/actions';
import CommonPageComponent from '../../../common/ui/CommonPageComponent';
import ParentCardNoCol from '../../common/ParentCardNoCol';
import * as pluginActions from '../../../features/plugin/redux/actions';
import { MultiTenantForm } from './MultiTenantForm';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import { Link, useHistory } from 'react-router-dom/cjs/react-router-dom.min';

export class MultiTenantPage extends Component {
  static propTypes = {
    onBoarding: PropTypes.object.isRequired,
    plugin: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    pluginActions: PropTypes.object.isRequired,
  };

  state = {
    addMultiTenant: false,
  };

  componentDidMount() {
    const { match, pluginActions } = this.props;
    const { projectId, version } = match.params;
    pluginActions.loadAllExtension({ projectId, version });
    pluginActions.loadAllInstalledPlugin({ projectId, version });
  }

  handleRadioChange = (event) => {
    const value = event.target.value === 'yes';
    this.setState({ addMultiTenant: value });
  };

  render() {
    const { match, plugin, actions } = this.props;
    const { projectId, version } = match.params;
    const { extensions, installedPlugins } = plugin;
    const { installMultiTenantPlugin } = actions;
    const multiTenantPlugin = extensions && extensions.find((e) => e.code === 'MULTI_TENANT_SAAS');

    const { addMultiTenant } = this.state;

    return (
      <CommonPageComponent>
        <div className="row mx-auto">
          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
            <ParentCardNoCol icon="on-boarding" title="Choose Multi-Tenant Capability">
              <div className="center-div">
                <div className="container ml-0">
                  <h5 style={{ textTransform: 'none' }}>
                    In this onboarding process, you'll have the option to add multi-tenant
                    capabilities to your application. Adding Multi-Tenant capability allows you to
                    manage multiple clients or users within a single instance of the application,
                    each with their own isolated data set.
                  </h5>

                  <h5 className="mb-5" style={{ textTransform: 'none' }}>
                    Would you like to add multi-tenant capabilities to your application by
                    installing the multi-tenant plugin?
                  </h5>

                  <div className="form-group col-md-6 mb-4">
                    <div className="custom-control custom-radio">
                      <input
                        type="radio"
                        className="custom-control-input"
                        id="addMultiTenantYes"
                        name="multiTenantOption"
                        value="yes"
                        checked={addMultiTenant === true}
                        onChange={this.handleRadioChange}
                      />
                      <label className="custom-control-label" htmlFor="addMultiTenantYes">
                        <h5 style={{ marginTop: '-5px' }}>
                          Yes, I want to add multi-tenant capabilities
                        </h5>
                      </label>
                    </div>
                    <div className="custom-control custom-radio" style={{ marginTop: '-15px' }}>
                      <input
                        type="radio"
                        className="custom-control-input"
                        id="addMultiTenantNo"
                        name="multiTenantOption"
                        value="no"
                        checked={addMultiTenant === false}
                        onChange={this.handleRadioChange}
                      />
                      <label className="custom-control-label" htmlFor="addMultiTenantNo">
                        <h5 style={{ marginTop: '-5px' }}>No, I’ll add it later (if needed)</h5>
                      </label>
                    </div>
                  </div>

                  {addMultiTenant ? (
                    <div style={{ paddingLeft: '15px' }}>
                      <h5 className="mb-0" style={{ textTransform: 'none' }}>
                        Please enter a collection name for your multi-tenant setup. This name will
                        be used to organize and manage your tenants.
                      </h5>
                      <span className="text-muted">
                        (Note: By default the Organisation collection will be used if Tenant
                        Collection Name field is left empty.)
                      </span>
                    </div>
                  ) : (
                    ''
                  )}

                  <div className="row">
                    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
                      {addMultiTenant === true ? (
                        <MultiTenantForm
                          projectId={projectId}
                          version={version}
                          multiTenantPlugin={multiTenantPlugin}
                          installedPlugins={installedPlugins}
                          installMultiTenantPlugin={installMultiTenantPlugin}
                          addMultiTenantFlag={addMultiTenant}
                        />
                      ) : addMultiTenant === false ? (
                        <div className="col-md-9 mb-2">
                          <h5 className="alert alert-info rounded">
                            Thank you! You can always add multi-tenant capabilities later from the
                            settings menu.
                          </h5>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
              {!addMultiTenant ? (
                <div className="fixed-button-bar mt-4">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-md-6 col-lg-6 col-sm-6 col-xs-6 text-left">
                        <Link
                          className="btn btn-outline-primary btn-md"
                          to={`/2.0/on-boarding/${version}/v/${projectId}/global-theme`}
                          title="Goto Next Step"
                        >
                          <i className="wb webconnect-skip-forward-fill"></i> Skip to next step
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ''
              )}
            </ParentCardNoCol>
          </div>
        </div>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    onBoarding: state.onBoarding,
    plugin: state.plugin,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    pluginActions: bindActionCreators({ ...pluginActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MultiTenantPage);
